import { supabase } from '@/lib/supabase/config';

export const logout = async () => {
  const { error } = await supabase.auth.signOut({ scope: 'global' });
  if (error) {
    throw error;
  }

  // Clear persisted Zustand stores from localStorage
  localStorage.removeItem('current-org-id');
  localStorage.removeItem('create-subproject');
  localStorage.removeItem('forecasts-hub');
};
